var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(-2390 -1952)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 22,
    height: 22,
    transform: "translate(2390 1952)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ikon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M2402.381,1967.945l6.66-6.66a1.841,1.841,0,0,0,0-2.6l-3.788-3.788a1.841,1.841,0,0,0-2.6,0l-6.66,6.66a1.833,1.833,0,0,0-.487,1.714l-2.543,2.543a1.844,1.844,0,0,0,0,2.606l2.559,2.559a1.836,1.836,0,0,0,1.31.538.575.575,0,0,0,.37.133h8.594a.614.614,0,0,0,0-1.228h-7.112l1.987-1.986a1.838,1.838,0,0,0,1.714-.487Zm-5.126,2.162a.631.631,0,0,1-.869,0l-2.559-2.559a.616.616,0,0,1,0-.87l2.342-2.342,3.429,3.429Zm-.4-6.821a.625.625,0,0,1,0-.866l6.66-6.66a.615.615,0,0,1,.868,0l3.788,3.789a.613.613,0,0,1,0,.868l-6.66,6.66a.626.626,0,0,1-.867,0Z",
    fill: "#636b91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEraser);
export default __webpack_public_path__ + "static/media/icon-eraser.6a980c0ec96280234ec5c1883ae35cc8.svg";
export { ForwardRef as ReactComponent };